<template>
  <div class="float_right">
    <br />
    <el-pagination
      class="text-center"
      layout="total,prev, pager, next,jumper"
      background
      :total="total"
      :page-size="10"
      @current-change="pageChangeFn"
    >
    </el-pagination>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
export default {
  props: ['total'],
  setup(props, { emit }) {
    const router = useRouter()
    const state = reactive({})

    onMounted(() => {})

    const pageChangeFn = value => {
      emit('pageChange', value)
    }

    return {
      ...toRefs(state),
      pageChangeFn,
    }
  },
}
</script>
<style lang="less">
.el-pagination.is-background .el-pager li:not(.is-disabled).is-active {
  background-color: #7ed6df;
}
</style>
